// app/javascript/controllers/yt_preview_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { id: String }

  play() {
    if (!this.hasIdValue) return
    const src = `https://www.youtube-nocookie.com/embed/${this.idValue}?autoplay=1&playsinline=1&rel=0&modestbranding=1`
    const iframe = document.createElement("iframe")
    iframe.src = src
    iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    iframe.allowFullscreen = true
    iframe.title = "YouTube video player"
    iframe.className = "aspect-video w-full"
    // 썸네일 버튼을 플레이어로 교체
    const button = this.element.querySelector("button[data-action]")
    button.replaceWith(iframe)
  }
}
